<script setup>
import { RouterView } from 'vue-router'
import { onMounted, ref } from 'vue'
import AppNavigation from './components/AppNavigation.vue'
import AppLoading from './components/AppLoading.vue'
import AppFooter from './components/AppFooter.vue'
import VerifyEmailAlert from './components/VerifyEmailAlert.vue'
import { useMainStore } from '@/stores/main'
import { Config } from '@/Config'

const store = useMainStore()
const initialLoading = ref(true)
const envVars = import.meta.env

// Initialize some store property.
store.setProperty('envVars', envVars)
store.setProperty('clientConfig', Config)

// Initialize user and language on app mount
onMounted(async () => {
  initialLoading.value = false
})
</script>

<template>
  <v-app>
    <!-- Loading Screen -->
    <AppLoading :show="initialLoading" />

    <!-- Main App Content -->
    <v-fade-transition>
      <div v-if="!initialLoading" class="app-content">
        <AppNavigation />
        <v-main>
          <VerifyEmailAlert />
          <RouterView />
        </v-main>
        <AppFooter />
      </div>
    </v-fade-transition>
  </v-app>
</template>

<style scoped>
.app-content {
  min-height: 100vh;
}

/* Fade transition for main app content */
.v-fade-transition-enter-active,
.v-fade-transition-leave-active {
  transition: opacity 0.5s ease-in-out;
}

.v-fade-transition-enter-from,
.v-fade-transition-leave-to {
  opacity: 0;
}
</style>


